import { callGuestAPI } from "../axios/guestAxios";

async function initiateCheckout(data) {
  const options = {
    method: "POST",
    url: "/reservation/v1/initiate-checkout",
    data,
  };
  const res = await callGuestAPI(options);
  return res;
}

async function storeTransaction(data) {
  const options = {
    method: "POST",
    url: "/reservation/v1/store-transaction",
    data,
  };
  const res = await callGuestAPI(options);
  return res;
}

const MpgsServices = {
  initiateCheckout,
  storeTransaction,
};

export default MpgsServices;
